import React, { useState, useEffect } from 'react';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, TextField, Tooltip, Box } from '@mui/material';
import styles from './styles.module.css'
import { parseFlagConciliacao } from '../../utils/conciliacao.util';

const TabelaConciliacaoExtrato = ({
    data,
    acoesDesabilitadas = false,
    handleValue,
    handleChangeCheckbox,
    handleInputChanges,
    handleSaveConciliacoes,
}) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [repetitions, setRepetitions] = useState({});

    const handleCheckbox = (rowData, e) => {
        handleChangeCheckbox(rowData, e.target.checked)
    }

    const handleRowSelect = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter(row => row !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const getRepetitions = () => {
        const repetitionsList = {};
        data.forEach((item, index) => {
            const key = item.transacaoId;
            if (!repetitionsList[key]) {
                repetitionsList[key] = [];
            }
            repetitionsList[key].push(index);
        });
        setRepetitions(repetitionsList)
    };

    useEffect(() => {
        getRepetitions()
        const listMap = data
            .map((item, index) => (parseFlagConciliacao(item.ignorado) ? index : null))
            .filter((index) => index != null);
        setSelectedRows(listMap);
    }, [data])

    const debouncedHandleInputChanges = (row, event) => {
        handleInputChanges(row, event.target);
    };

    return (
        <Box className={styles.tabelaConciliacaoWrapper}>
            <TableContainer
                component={Paper}
                className={styles.tabelaConciliacaoScroll}
            >
                <Table size='small'>
                    <TableHead >
                        <TableRow className={styles.headerTabela}>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'6px'}}>Ignorar</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Data de<br/>Transação</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>ID da <br/>Transação</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Descrição da Transação</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Quantia</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Conta do Débito</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Descrição da<br/>Conta do Débito</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Conta do Crédito</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Descrição da<br/>Conta do Crédito</TableCell>
                            <TableCell className={styles.itemHeaderTabela} sx={{padding:'8px'}}>Código do<br/>Fornecedor</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) => {
                            const isSelected = parseFlagConciliacao(
                                handleValue(row.idConciliacaoConciliacao, "ignorado")
                            );
                            const repetitionIndexes = repetitions[row.transacaoId] || [];
                            const isDuplicate = repetitionIndexes.length > 1;
                            const isLastUnselectedDuplicate = isDuplicate && repetitionIndexes.filter(idx => !selectedRows.includes(idx)).length === 1 && !isSelected;
                            const style = {
                                textAlign: 'center',
                                color: isDuplicate ? (isSelected ? '#999999' : (isLastUnselectedDuplicate ? 'black' : 'red')) : '',
                                borderBottom: isDuplicate ? (isSelected ? '1px solid #999999' : (isLastUnselectedDuplicate ? '1px solid black' : '1px solid red')) : '',
                                paddingY: 0.2,
                                paddingX: 0.6,
                            };
                            const styleWithouttextAlign = {
                                ...style,
                                textAlign: 'left',
                            }
                            const descContaDebito = handleValue(row.idConciliacaoConciliacao, "descricaoContaContabilDebito");
                            const descContaCredito = handleValue(row.idConciliacaoConciliacao, "descricaoContaContabilCredito");
                            return (
                                <TableRow key={row.idConciliacaoConciliacao} sx={style}>
                                    <TableCell sx={style}>
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            disabled={acoesDesabilitadas}
                                            onChange={(e) => {
                                                if (acoesDesabilitadas) return;
                                                handleRowSelect(index)
                                                handleCheckbox(row, e)
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={style}>{row.dtTransacao}</TableCell>
                                    <TableCell sx={style}>{row.transacaoId}</TableCell>
                                    <TableCell sx={styleWithouttextAlign}>
                                        <Tooltip title={row.descricaoTransacao ?? ''} placement="top" enterDelay={400}>
                                            <Box
                                                component="span"
                                                sx={{
                                                    display: 'block',
                                                    maxWidth: '14rem',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {row.descricaoTransacao}
                                            </Box>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell sx={styleWithouttextAlign}>{row.quantia_cellVal}</TableCell>
                                    <TableCell sx={style}>{
                                        <TextField
                                            size='small'
                                            sx={{ width: '8rem' }}
                                            disabled
                                            name="contaContabilDebito"
                                            value={handleValue(row.idConciliacaoConciliacao, "contaContabilDebito")}
                                            onChange={(event) => debouncedHandleInputChanges(row, event)}
                                            onBlur={() => handleSaveConciliacoes()}
                                        />}
                                    </TableCell>
                                    <TableCell sx={style}>{
                                        <Tooltip
                                            title={String(descContaDebito ?? '')}
                                            placement="top"
                                            enterDelay={400}
                                        >
                                            <span style={{ display: 'inline-block', width: '100%' }}>
                                                <TextField
                                                    size='small'
                                                    sx={{ width: '8rem' }}
                                                    disabled
                                                    name="descricaoContaContabilDebito"
                                                    value={descContaDebito}
                                                    onChange={(event) => debouncedHandleInputChanges(row, event)}
                                                    onBlur={() => handleSaveConciliacoes()}
                                                />
                                            </span>
                                        </Tooltip>}
                                    </TableCell>
                                    <TableCell sx={style}>{
                                        <TextField
                                            size='small'
                                            sx={{ width: '8rem' }}
                                            disabled
                                            name="contaContabilCredito"
                                            value={handleValue(row.idConciliacaoConciliacao, "contaContabilCredito")}
                                            onChange={(event) => debouncedHandleInputChanges(row, event)}
                                            onBlur={() => handleSaveConciliacoes()}
                                        />}
                                    </TableCell>
                                    <TableCell sx={style}>{
                                        <Tooltip
                                            title={String(descContaCredito ?? '')}
                                            placement="top"
                                            enterDelay={400}
                                        >
                                            <span style={{ display: 'inline-block', width: '100%' }}>
                                                <TextField
                                                    size='small'
                                                    sx={{ width: '8rem' }}
                                                    disabled
                                                    name="descricaoContaContabilCredito"
                                                    value={descContaCredito}
                                                    onChange={(event) => debouncedHandleInputChanges(row, event)}
                                                    onBlur={() => handleSaveConciliacoes()}
                                                />
                                            </span>
                                        </Tooltip>}
                                    </TableCell>
                                    <TableCell sx={style}>{
                                        <TextField
                                            size='small'
                                            sx={{ width: '8rem' }}
                                            disabled
                                            name="codigoFornecedor"
                                            value={handleValue(row.idConciliacaoConciliacao, "codigoFornecedor")}
                                            onChange={(event) => debouncedHandleInputChanges(row, event)}
                                            onBlur={() => handleSaveConciliacoes()}
                                        />}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default TabelaConciliacaoExtrato;
